<script>
import { mapState, mapActions, mapGetters } from "vuex";
import ClientFactory from "@/api/ClientFactory";
import { VueGoodTable } from 'vue-good-table';
const dropdownsApi = ClientFactory.get("dropdowns");

const emulationApi = ClientFactory.get("emulations");

export default {
  components: {
      VueGoodTable
  },
  data(){
    return {
      total: 0,
      emulation_delete_id: 0,
      emulation_group_id:0,
      department_id: null,
      employee_id: null,
      full_name:"",
      approver_status:1000,
      year: new Date().getFullYear(),
      currentMonth: new Date().getMonth()+1,
      note:"",
      columns: [
        {
          label: 'Trạng thái',
          field: 'approver_status_name',
          thClass: 'emu-vgt-thead-th text-center width-status',
          tdClass: 'emu-vgt-tbody-td text-center width-status',
        },
        {
          label: 'Tháng',
          field: 'time',
          thClass: 'emu-vgt-thead-th text-center width-status',
          tdClass: 'emu-vgt-tbody-td text-center width-status',
        },
        {
          label: 'Họ và Tên',
          field: 'full_name',
          thClass: 'emu-vgt-thead-th text-center',
          tdClass: 'emu-vgt-tbody-td',
        },
        {
          label: 'Điểm cá nhân chấm',
          field: 'total_point_self_rating',
          thClass: 'emu-vgt-thead-th text-center width-status',
          tdClass: 'emu-vgt-tbody-td text-center width-status',
        },
        {
          label: 'Điểm phòng chấm',
          field: 'total_point_department_rating',
          thClass: 'emu-vgt-thead-th text-center width-status',
          tdClass: 'emu-vgt-tbody-td text-center width-status',
        },
        {
          label: 'Xếp loại',
          field: 'graded',
          thClass: 'emu-vgt-thead-th text-center width-status',
          tdClass: 'emu-vgt-tbody-td text-center width-status',
        },
        {
          label: 'Ý kiến của lãnh đạo',
          field: 'department_note',
          thClass: 'emu-vgt-thead-th text-center width-point',
          tdClass: 'emu-vgt-tbody-td text-center width-point',
        },
        {
          label: 'Thao tác',
          field: 'action',
          thClass: 'emu-vgt-thead-th text-center',
          tdClass: 'emu-vgt-tbody-td text-center',
          width: '100px',
        },
      ],
       data: [
      ],
      group_emulation:[
      ],
      years: [],
      months: [
        {
          value: 1,
          label: "Tháng 1",
        },
        {
          value: 2,
          label: "Tháng 2",
        },
        {
          value: 3,
          label: "Tháng 3",
        },
        {
          value: 4,
          label: "Tháng 4",
        },
        {
          value: 5,
          label: "Tháng 5",
        },
        {
          value: 6,
          label: "Tháng 6",
        },
        {
          value: 7,
          label: "Tháng 7",
        },
        {
          value: 8,
          label: "Tháng 8",
        },
        {
          value: 9,
          label: "Tháng 9",
        },
        {
          value: 10,
          label: "Tháng 10",
        },
        {
          value: 11,
          label: "Tháng 11",
        },
        {
          value: 12,
          label: "Tháng 12",
        },
      ],
      data_approver_status:[
        {
          value: 1000,
          label: "Tất cả",
        },
        {
          value: 1,
          label: "Đã duyệt",
        },
        {
          value: 0,
          label: "Chờ duyệt",
        },
        // {
        //   value: 4,
        //   label: "Gửi văn phòng",
        // },
        {
          value: 5,
          label: "Văn phòng trả lại",
        },
      ],
      state: {
          dialog: {
              detail: false,
              delete: false
          }
      },
    };
  },
  async created() {
    this.employee_id= this.AppActiveUser.employee_id;
    this.years = await dropdownsApi.get(dropdownsApi.type.YEARS);
    await this.getEmulationGroup();
    ({
        year:this.year,
        currentMonth:this.currentMonth,
        full_name:this.full_name,
        emulation_group_id:this.emulation_group_id,
        approver_status:this.approver_status
      } = this.filterLDCD);

    this.department_id= this.AppActiveUser.department_id;
    console.log(this.department_id);
    this.getEmulation();
  },
  methods: {
    ...mapActions("ui", ['loading', 'closeLoading', 'notify']),
    ...mapActions("EmulationStore", ["saveLDCDSearchFilter"]),
    getEmulation: async function () {
      
      this.loading(this.$vs);

      this.saveLDCDSearchFilter({
        filter: {
          year:this.year,
          currentMonth:this.currentMonth,
          full_name:this.full_name,
          emulation_group_id:this.emulation_group_id,
          approver_status:this.approver_status
        },
      });
      const { data } = await emulationApi.getEmulationDepartment(
        this.year,
        this.currentMonth,
        this.full_name,
        this.department_id,
        this.emulation_group_id,
        this.approver_status
      );
      this.closeLoading();
      this.checkResponseData(data);
    },

    getEmulationGroup: async function () {
      const { data } = await emulationApi.getGroupByEmployee(this.employee_id);
      
      if(data.status == "success")
      { 
          if(data.data[0].groups != null) {
            this.emulation_group_id = data.data[0].groups[0].value;
            this.group_emulation = data.data[0].groups;
            this.saveLDCDSearchFilter({
                filter: {
                  ...this.filterLDCD,
                  emulation_group_id:this.emulation_group_id
                },
              });

          }else
          {
            this.group_emulation =[];
          } 
      }
    },

    checkResponseData(data) {
      if(data.status == "success")
      { 
        if(data.data[0].id != undefined)
          this.data = data.data;
        else
          this.data = [];

      }else{
        this.notify({
          error:true,
          title: "Thông báo",
          text: data.message
        });
      }
     },

    rowStyleClassFn(row) {
      return row.is_title > 0 ? 'header-row' : '';
    },

    selectStyleClass() {
      return 'emu-select';
    },

    goUpdateEmulation(emulationId) {
        this.$router.push({path: `department_edit/${emulationId}`}).catch(() => {});
    },
    goDetailEmulation(emulationId) {
        this.$router.push({path: `detail/${emulationId}`}).catch(() => {});
    },
    searchEmulation(){
      this.getEmulation();
    }
  },
  computed: {
    ...mapState("auth", ["AppActiveUser"]),
    ...mapGetters("EmulationStore", ["filterLDCD"]),
  },
  destroyed() {
    this.closeLoading();
  }
};

</script>

<template>
  <div class="department_rating">
    <CCard title="Quản lý chấm điểm tháng" class="mb-2">
      <CCardHeader class="pt-1 pb-1">
          <span class="card-header-title">Duyệt bảng chấm điểm thi đua</span>
      </CCardHeader>
      <CCardBody class="pt-1 pb-0">
        <CRow class="mt-2">
          <CCol sm="2">
              <label class='mb-0'>Họ và tên</label>
              <CInput
                :value.sync="full_name"
                />
            </CCol>
            <CCol sm="2">
              <label class='mb-0'>Trạng thái</label>
              <CSelect
                :options='data_approver_status'
                :value.sync="approver_status"
                @change="getEmulation"
              />
            </CCol>
            <CCol sm="2">
              <label class='mb-0'>Năm</label>
              <CSelect
              id="years"
                :options=years
                :value.sync="year"
                @change="getEmulation"
              />
            </CCol>
            <CCol sm="2">
              <label class='mb-0'>Tháng</label>
              <CSelect
              id="months"
                :options=months
                :value.sync="currentMonth"
                @change="getEmulation"
              />
            </CCol>
            <CCol sm="4">
              <label class='mb-0'>Nhóm thi đua</label>
              <CSelect
                :options=group_emulation
                :value.sync="emulation_group_id"
                @change="getEmulation"
              />
            </CCol>
        </CRow>
        <CRow>
            <CCol sm="12" class="center">
              <vs-button warn square class="custom_btn_search"  @click="searchEmulation()"><i class='bx bx-search'></i>Tìm kiếm</vs-button>
            </CCol>
        </CRow>
      </CCardBody>
    </CCard>
    <CCard>
        <vue-good-table
          :columns="columns"
          :rows="data"
          compactMode
          :sort-options="{
            enabled:false
          }"
          :pagination-options="{
              enabled: true,
              perPage: 100,
              perPageDropdownEnabled: false,
              nextLabel: 'Trang sau',
              prevLabel: 'Trang trước',
              ofLabel: 'của',
          }"
          :line-numbers="true"
          :row-style-class="rowStyleClassFn"
        >
          <div slot="emptystate">
            Không có dữ liệu
          </div>
          <template
            slot="table-row"
            slot-scope="props"
          >
              <div v-if="props.column.field === 'approver_status_name'">
                  <CBadge v-if="props.row.approver_status == 1" color="success">{{props.row.approver_status_name}}</CBadge>
                  <CBadge v-else-if="props.row.approver_status == 0" color="warning">{{props.row.approver_status_name}}</CBadge>
                  <CBadge v-else-if="props.row.approver_status == 2" color="warning">{{props.row.approver_status_name}}</CBadge>
                  <CBadge v-else-if="props.row.approver_status == 4" color="warning">{{props.row.approver_status_name}}</CBadge>
                  <CBadge v-else-if="props.row.approver_status == 5" color="warning">{{props.row.approver_status_name}}</CBadge>
                  <CBadge v-else color="danger">{{props.row.approver_status_name}}</CBadge>
              </div>
              <div v-else-if="props.column.field === 'total_point_department_rating'">
                  <span v-if="props.row.total_point_department_rating >0">{{props.row.total_point_department_rating}}</span>
                  <span v-else>--</span>
              </div>
              <div v-else-if="props.column.field === 'graded'">
                  <span v-if="props.row.graded != null">{{props.row.graded}}</span>
                  <span v-else>--</span>
              </div>
              <div v-else-if="props.column.field === 'action'" class="row center">
                  <vs-tooltip color="square">
                      <vs-button transparent @click="goDetailEmulation(props.row.id)"  square circle icon><i class='bx bxs-info-circle'></i></vs-button>
                      <template #tooltip>
                          Chi tiết
                      </template>
                  </vs-tooltip>
                  <!-- Chờ duyệt -->
                  <vs-tooltip v-if="props.row.approver_status == 0" color="success">
                    <vs-button transparent @click="goUpdateEmulation(props.row.id)"  success circle icon><i class='bx bx-check-circle' ></i></vs-button>
                      <template #tooltip>
                          Duyệt
                      </template>
                  </vs-tooltip>
                  <!-- Văn phòng trả lại -->
                  <vs-tooltip v-if="props.row.approver_status == 5" color="success">
                    <vs-button transparent @click="goUpdateEmulation(props.row.id)"  success circle icon><i class='bx bx-check-circle' ></i></vs-button>
                      <template #tooltip>
                          Duyệt
                      </template>
                  </vs-tooltip>
              </div>
              
          </template>
        </vue-good-table> 
    </CCard>
  </div>
</template>

<style lang="scss">
  .department_rating{
    table.vgt-table td {
      vertical-align: inherit;
      padding: 0em .75em .0em .75em;
    }
    .vgt-responsive {
        overflow-x: inherit;
    }
    .width-class{
      min-width: 3px !important;
    }
    .width-status{
      min-width: 10px !important;
    }
  }
</style>